export default "__VITE_ASSET__Dj5K9MiW__"